module.exports = __webpack_public_path__ + "static/media/BigArrowDown.61955dff.svg";